import { useNavigate } from "react-router-dom";
import { useMode } from "@/context/ModeContext";
import { Wrench, HeartHandshake } from "lucide-react";

// mode toggle between SERVICES (navy) and HOMIIE CARE (coral). Navigates on switch.
// `full` renders a large, full-width segmented control (used in home headers).
export function ModeSwitch({ className = "", full = false }) {
    const { mode, setMode } = useMode();
    const nav = useNavigate();
    const go = (m) => { setMode(m); nav(m === "care" ? "/care" : "/"); };
    const care = mode === "care";

    if (full) {
        return (
            <div data-testid="mode-switch" className={`flex items-center gap-2 rounded-2xl bg-navy/5 p-1.5 ${className}`}>
                <button data-testid="mode-services-btn" onClick={() => go("services")}
                    className={`flex flex-1 items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-bold transition-all ${!care ? "bg-navy text-white shadow-[0_6px_16px_-6px_rgba(16,42,67,0.5)]" : "text-navy/45"}`}>
                    <Wrench size={16} /> Services
                </button>
                <button data-testid="mode-care-btn" onClick={() => go("care")}
                    className={`flex flex-1 items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-bold transition-all ${care ? "bg-[#F43F5E] text-white shadow-[0_6px_16px_-6px_rgba(244,63,94,0.5)]" : "text-navy/45"}`}>
                    <HeartHandshake size={16} /> Homiie Care
                </button>
            </div>
        );
    }

    return (
        <div data-testid="mode-switch" className={`inline-flex items-center rounded-full p-1 ${care ? "bg-white/60" : "bg-navy/5"} ${className}`}>
            <button data-testid="mode-services-btn" onClick={() => go("services")}
                className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-all ${!care ? "bg-navy text-white shadow" : "text-navy/50"}`}>
                <Wrench size={13} /> Services
            </button>
            <button data-testid="mode-care-btn" onClick={() => go("care")}
                className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-all ${care ? "bg-[#F43F5E] text-white shadow" : "text-navy/50"}`}>
                <HeartHandshake size={13} /> Homiie Care
            </button>
        </div>
    );
}
